export const CACHIFIED_OPTIONS = 'cachified:options';
export const CACHIFIED_DECORATOR = 'cachified:decorator';